module.exports = __webpack_public_path__ + "img/SB_18.a3bfb489.png";